export default "__VITE_ASSET__DXxw9ivi__"